export class ImageZoom {
  constructor() {
    this.eventType = this._getEventType();
    this.$images = document.querySelectorAll('.js-cp-image');
    this.$cover = document.querySelector('.js-zoom-cover');
    this._addEvent();
  }
  _getEventType() {
    const isTouchCapable =
      'ontouchstart' in window ||
      (window.DocumentTouch && document instanceof DocumentTouch);

    return isTouchCapable ? 'touchstart' : 'click';
  }

  _classAdd(e) {
    let $parent = e.parentNode;
    let $cloneImageWrap = $parent.cloneNode(true);
    $cloneImageWrap.classList.add('is-clone', 'is-zoom');
    $parent.after($cloneImageWrap);
    this.$cover.classList.add('is-cover-open');
  }

  _calssRemove() {
    this.$cover.classList.remove('is-cover-open');

    const elementsToRemove = document.querySelectorAll('.is-zoom');
    elementsToRemove.forEach(function (element) {
      element.remove();
    });
  }

  _addEvent() {
    let windowSize = window.innerWidth;
    window.addEventListener('resize', () => {
      windowSize = window.innerWidth;
    });

    this.$cover.addEventListener(this.eventType, () => {
      if (windowSize < 600) {
        this._calssRemove();
      }
    });

    let count = 0;

    this.$images.forEach((image) => {
      image.addEventListener(this.eventType, (element) => {
        if (windowSize < 600) {
          if (!count) {
            ++count;
            setTimeout(function () {
              count = 0;
            }, 500);
          } else {
            element.preventDefault();

            if (!image.classList.contains('is-zoom')) {
              this._classAdd(image);
            } else {
              this._calssRemove();
            }

            count = 0;
          }
        }
      });
    });
  }
}
